// Voysi Sparkline. Port of voysi-shell.jsx::Sparkline.
// Pure SVG, no dependencies. Renders a smooth line + faint area fill and a
// single dot on the latest value.

interface SparklineProps {
  data: number[]
  color?: string
  width?: number
  height?: number
  fill?: boolean
  className?: string
}

export function Sparkline({
  data,
  color = '#FF3D84',
  width = 240,
  height = 60,
  fill = true,
  className,
}: SparklineProps) {
  if (data.length === 0) return null
  const max = Math.max(...data)
  const min = Math.min(...data)
  const range = Math.max(max - min, 1)
  const pts = data.map((v, i) => {
    const x = (i / Math.max(data.length - 1, 1)) * width
    const y = height - ((v - min) / range) * (height - 8) - 4
    return [x, y] as const
  })
  const path = pts.map(([x, y], i) => `${i ? 'L' : 'M'}${x.toFixed(1)} ${y.toFixed(1)}`).join(' ')
  const area = `${path} L${width} ${height} L0 ${height} Z`
  const last = pts[pts.length - 1]!
  return (
    <svg width={width} height={height} className={className} style={{ display: 'block' }}>
      {fill && <path d={area} fill={color} opacity={0.12} />}
      <path
        d={path}
        stroke={color}
        strokeWidth={2}
        fill="none"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <circle cx={last[0]} cy={last[1]} r={3.5} fill={color} />
    </svg>
  )
}
